import { render, staticRenderFns } from "./table_card.vue?vue&type=template&id=c79e2e56&scoped=true"
import script from "./table_card.vue?vue&type=script&lang=js"
export * from "./table_card.vue?vue&type=script&lang=js"
import style0 from "./table_card.vue?vue&type=style&index=0&id=c79e2e56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79e2e56",
  null
  
)

export default component.exports